import React from 'react';
const SpinnerSmallSvg = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 5,
  stroke: "currentColor",
  strokeWidth: 2,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M13 8a5 5 0 0 0-5-5"
}));
export default SpinnerSmallSvg;